/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Csv_To_Json_Faq_A4Inputs */

const en_csv_to_json_faq_a4 = /** @type {(inputs: Csv_To_Json_Faq_A4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The comma only. Tab and semicolon separated files are not parsed, which matters for exports from spreadsheets in locales that use the comma as a decimal separator. Re-export as comma separated first.`)
};

const ko_csv_to_json_faq_a4 = /** @type {(inputs: Csv_To_Json_Faq_A4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`쉼표만입니다. 탭과 세미콜론 구분 파일은 파싱되지 않으며, 이는 쉼표를 소수점 구분자로 쓰는 로케일의 스프레드시트 내보내기에서 문제가 됩니다. 먼저 쉼표 구분으로 다시 내보내세요.`)
};

const ja_csv_to_json_faq_a4 = /** @type {(inputs: Csv_To_Json_Faq_A4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`カンマだけです。タブとセミコロン区切りのファイルはパースされず、これはカンマを小数点区切りに使うロケールの表計算のエクスポートで問題になります。先にカンマ区切りで再エクスポートしてください。`)
};

/**
* | output |
* | --- |
* | "The comma only. Tab and semicolon separated files are not parsed, which matters for exports from spreadsheets in locales that use the comma as a decimal sepa..." |
*
* @param {Csv_To_Json_Faq_A4Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const csv_to_json_faq_a4 = /** @type {((inputs?: Csv_To_Json_Faq_A4Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Csv_To_Json_Faq_A4Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_csv_to_json_faq_a4(inputs)
	if (locale === "ko") return ko_csv_to_json_faq_a4(inputs)
	return ja_csv_to_json_faq_a4(inputs)
});